//
import { Component } from "react"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    EmailTargetedInGrassrootsActionFilter,
    GrassrootsActionAuthorizedContributionAmountFilter,
    GrassrootsActionAuthorizedContributionPayrollFrequencyFilter,
    GrassrootsActionCharityNameFilter,
    GrassrootsActionEmailFilter,
    GrassrootsActionHasSelectedACharityFilter,
    GrassrootsActionRegistrationFormSourceFilter,
    GrassrootsActionSocialMediaTypeFilter,
    GrassrootsActionSourceFilter,
    GrassrootsActionPaymentTypeFilter,
    GrassrootsActionSubmittingOrganizationFilter,
    GrassrootsActionSupporterPacConditionalGivingLevelFilter,
    GrassrootsActionTypeFilter,
    GrassrootsActionUTMSourceFilter,
} from "shared/search/containers/Filter/GrassrootsActionFilters"
import { createGACampaignFilterGroup } from "shared/search/containers/FilterGroup/GrassrootsActionCampaignFilterGroup"
import { NoteInvolvingMemberFilter, NoteInvolvingSupporterFilter } from "shared/search/containers/Filter/NoteFilters"
import { checkPermission } from "shared/imports/permissionFunctions"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    DatePickerStartFilterESTDateOnly,
    DatePickerEndFilterESTDateOnly,
} from "shared/search/containers/Filter/Filters"
import { createCustomQuestionFilterGroup } from "shared/search/containers/FilterGroup/CustomQuestionFilterGroup"

export const GrassrootsActionCampaignFilterGroup = createGACampaignFilterGroup()

export const GrassrootsCustomActionFieldsFilterGroup = createCustomQuestionFilterGroup(
    DjangIO.app.models.QuorumDataType.grassroots_action.value,
)

export class GrassrootsActionDateFilterGroup extends Component {
    static defaultProps = {
        filters: [DatePickerStartFilterESTDateOnly, DatePickerEndFilterESTDateOnly],
        uniqueFilterGroupId: "gaDateFilterGroup",
        displayLabel: "Date",
        helpText:
            "Filter by full days in Eastern Time. Includes all actions from 12:00 AM to 11:59 PM EST on selected dates.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [GrassrootsActionTypeFilter],
        uniqueFilterGroupId: "gaTypeFilterGroup",
        displayLabel: "Action Type",
        helpText: "Filter actions by type of grassroots interaction.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionSourceFilterGroup extends Component {
    static defaultProps = {
        filters: [
            GrassrootsActionSourceFilter,
            GrassrootsActionEmailFilter,
            GrassrootsActionUTMSourceFilter,
            GrassrootsActionRegistrationFormSourceFilter,
        ],
        uniqueFilterGroupId: "gaSourceFilterGroup",
        displayLabel: "Source",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionSocialMediaTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [GrassrootsActionSocialMediaTypeFilter],
        uniqueFilterGroupId: "gaSocialMediaTypeFilterGroup",
        displayLabel: "Social Media Sharing",
        helpText: "Filter actions by the social media the campaign was shared on (only Share a Link campaigns)",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionInvolvingFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteInvolvingMemberFilter, NoteInvolvingSupporterFilter, EmailTargetedInGrassrootsActionFilter],
        uniqueFilterGroupId: "gaParticipantsFilterGroup",
        displayLabel: "Participants",
        helpText: "Filter actions by the participants involved.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionBulkEmailFilterGroup extends Component {
    static defaultProps = {
        filters: [GrassrootsActionEmailFilter],
        uniqueFilterGroupId: "gaBulkEmailFilterGroup",
        displayLabel: "Outbox",
        helpText: "Filter actions by which Outbox email campaign led to the action.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.grassroots_action.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.grassroots_action.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "grassrootsListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter results by the lists that you have saved them to in Issues.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionSubmittingOrganizationFilterGroup extends Component {
    static defaultProps = {
        filters: [GrassrootsActionSubmittingOrganizationFilter],
        uniqueFilterGroupId: "grassrootsSubmittingOrgFilterGroup",
        displayLabel: "Submitting Organization",
        helpText: "Filter results by the name of the submitting organization (only Comment on Regulation campaigns)",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class GrassrootsActionPacFilterGroup extends Component {
    static defaultProps = {
        filters: [
            GrassrootsActionAuthorizedContributionAmountFilter,
            GrassrootsActionAuthorizedContributionPayrollFrequencyFilter,
            GrassrootsActionSupporterPacConditionalGivingLevelFilter,
            GrassrootsActionPaymentTypeFilter,
            ...(checkPermission(DjangIO.app.models.PermissionType.pac_match)
                ? [GrassrootsActionHasSelectedACharityFilter, GrassrootsActionCharityNameFilter]
                : []),
        ],
        uniqueFilterGroupId: "grassrootsPacFilterGroup",
        displayLabel: "PAC",
        helpText: "Filter authorized contributions by Amount or Payroll Frequency",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
